import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Section';
import { BrandLogo } from '@/components/brand/BrandLogo';

export const CONTACT = {
  plant: { label: 'Produksjonsanlegg', street: 'Omviksdalvegen 415', postal: '5464 Dimmelsvik', address: 'Omviksdalvegen 415, 5464 Dimmelsvik', phone: '+47 950 12 961', phoneHref: 'tel:+4795012961', email: 'post@hardangerrock.no' },
  admin: { label: 'Administrasjon', street: 'Dalane 29', postal: '4137 Årdal i Ryfylke', address: 'Dalane 29, 4137 Årdal i Ryfylke', email: 'rm@hardangerrock.no' },
  people: [
    { name: 'Robert Myklebust', title: 'Daglig leder', email: 'rm@hardangerrock.no' },
    { name: 'Jon Steinar Vivelid', title: 'Produksjons- og vedlikeholdssjef', phone: '+47 951 25 640', phoneHref: 'tel:+4795125640' },
    { name: 'Torstein Riskedal', title: 'Kvalitetssikringssjef', phone: '+47 900 10 183', phoneHref: 'tel:+4790010183' },
  ],
};

const COLUMNS = [
  {
    title: 'Produkter og bestilling',
    links: [
      { label: 'Knust sand', to: '/produkter?kategori=sand' },
      { label: 'Grus', to: '/produkter?kategori=grus' },
      { label: 'Pukk', to: '/produkter?kategori=pukk' },
      { label: 'Stein og big bag', to: '/produkter?kategori=spesial' },
      { label: 'Be om tilbud', to: '/prosjekt' },
    ],
  },
  {
    title: 'Dokumentasjon',
    links: [
      { label: 'Ytelseserklæringer og CE-dokumentasjon', href: 'https://hardangerrock.no/ce-deklarasjoner-eksterne-tester-og-proveresultater/#ce-deklarasjoner' },
      { label: 'Eksterne prøveresultater', href: 'https://hardangerrock.no/ce-deklarasjoner-eksterne-tester-og-proveresultater/#eksterne-tester-og-proveresultater' },
      { label: 'CSR-sertifikat', href: 'https://hardangerrock.no/ce-deklarasjoner-eksterne-tester-og-proveresultater/#crs-sertifikat' },
    ],
  },
  {
    title: 'For ansatte',
    links: [{ label: 'Åpne produksjonsportalen (demo)', to: '/login', testId: 'footer-portal-link' }],
  },
];

const LINK = 'site-ul inline text-[14.5px] leading-7 text-white/80 transition-colors duration-150 hover:text-white';

export function SiteFooter() {
  return (
    <footer className="site relative overflow-hidden bg-[var(--site-ink)] text-white" data-testid="site-footer">
      <Container className="grid gap-12 py-16 sm:py-20 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-4">
          <BrandLogo variant="whiteOrange" className="h-9 w-auto" testId="footer-logo" />
          <p className="mt-6 max-w-[34ch] text-[15px] leading-7 text-white/70">Pukk, grus, knust sand og stein fra Dimmelsvik i Kvinnherad. Hent på anlegget, eller få massene levert til prosjektet ditt.</p>
          <div className="mt-8 space-y-2">
            <a href={CONTACT.plant.phoneHref} className="hr-tabular site-ul inline-block font-display text-[22px] font-semibold tracking-[-0.02em] text-white">
              {CONTACT.plant.phone}
            </a>
            <br />
            <a href={`mailto:${CONTACT.plant.email}`} className="site-ul inline-block text-[15px] text-white/80 hover:text-white">
              {CONTACT.plant.email}
            </a>
          </div>
        </div>
        {COLUMNS.map((col, i) => (
          <div key={col.title} className={i === 0 ? 'lg:col-span-2' : i === 1 ? 'lg:col-span-3' : 'lg:col-span-3'}>
            <h3 className="text-[13.5px] font-semibold text-white/55">{col.title}</h3>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} className={LINK} data-testid={l.testId}>
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} target="_blank" rel="noreferrer" className={LINK}>
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
            {i === 2 && (
              <dl className="mt-8 space-y-5 text-[14.5px]">
                <div>
                  <dt className="text-white/55">{CONTACT.plant.label}</dt>
                  <dd className="mt-1 text-white/85">
                    {CONTACT.plant.street}
                    <br />
                    {CONTACT.plant.postal}
                  </dd>
                </div>
                <div>
                  <dt className="text-white/55">{CONTACT.admin.label}</dt>
                  <dd className="mt-1 text-white/85">
                    {CONTACT.admin.street}
                    <br />
                    {CONTACT.admin.postal}
                  </dd>
                </div>
              </dl>
            )}
          </div>
        ))}
      </Container>

      {/* Stort ordmerke – typografisk signatur nederst */}
      <div className="select-none overflow-hidden px-5 pt-4 sm:px-8 lg:px-10" aria-hidden="true">
        <div className="whitespace-nowrap font-display text-[clamp(40px,10.5vw,200px)] font-bold leading-[0.85] tracking-[-0.045em] text-white/[0.07]">Hardanger Rock</div>
      </div>

      <div className="border-t border-white/10">
        <Container className="flex flex-col gap-1.5 py-5 text-[13px] text-white/55 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Hardanger Rock AS</span>
          <span>Tonnpriser eks. mva. · Betalingsfrist 10 dager · Frakt og prosjektpriser på forespørsel</span>
        </Container>
      </div>
    </footer>
  );
}
